<template>
<div class="container px-0 py-2">
    <div class="card p-3 my-2">
        <div class="d-flex justify-content-around align-items-center">
            <div class="flex flex-grow-1" v-if="exercise.translation">
                <h1 class="mb-0">{{exercise.translation.title}}</h1>
            </div>
            <exercise-timer ref="timer" v-if="exercise.time && !exercise.finished" />
        </div>
        <div v-if="finished" class="exercise-score">
            <h2>
                <i class="mdi mdi-octagram"/>
                {{$t('common.final_grade')}}: {{exercise.grade}}
            </h2>
            <h2>
                <i class="mdi mdi-circle-slice-1"/>
                {{$t('content.exercise.utilization')}}: {{exercise.grade_percentage}}%
            </h2>
        </div>
    </div>
    <timer-confirmation v-if="exercise.time" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import ProgressBar from '../../../Common/ProgressBar';
import CertificateLink from '../../../Certificate/CertificateLink';
import TimerConfirmation from './ClassExerciseTimerConfirmation';
import ExerciseTimer from './ClassExerciseTimer';

export default {
    name: 'ClassExerciseHeader',

    components: {
        ProgressBar,
        CertificateLink,
        TimerConfirmation,
        ExerciseTimer,
    },

    props: {
        finished: Boolean,
    },

    computed: mapGetters({
        exercise: 'CLASS_EXERCISE',
        color: 'COLOR',
    }),
};
</script>

<style lang="sass" scoped>
.exercise-score
    display: flex
    flex-direction: column
    margin-bottom: 1rem
</style>
